import { render, staticRenderFns } from "./GeneralCampusAttribution.vue?vue&type=template&id=5f4052a6"
import script from "./GeneralCampusAttribution.vue?vue&type=script&lang=js"
export * from "./GeneralCampusAttribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f4052a6')) {
      api.createRecord('5f4052a6', component.options)
    } else {
      api.reload('5f4052a6', component.options)
    }
    module.hot.accept("./GeneralCampusAttribution.vue?vue&type=template&id=5f4052a6", function () {
      api.rerender('5f4052a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/chart/GeneralCampusAttribution.vue"
export default component.exports